import React, { useContext, useEffect, useState } from "react"
import { globalContext } from "../../components/context"
import { phoneList } from "../../utils/constant"
import "./phone.sass"

const Phone = () => {
  const { intl, country } = useContext(globalContext)
  const [list, setList] = useState([])

  useEffect(() => {
    setList(phoneList[country][intl.locale])
  }, [country, intl.locale])

  return (
    <div className="driver-phone">
      <div className="container">
        <h3>{intl.formatMessage({ id: "driver.contact.title" })}</h3>
        <div className=" phone-list">
          {list.length > 0
            ? list.map(item => (
                <div key={item.city} className="phone-list-item">
                  {item.city}:<a href={`tel:${item.phone}`}>{item.phone}</a>
                </div>
              ))
            : intl.formatMessage({ id: "driver.contact.empty" })}
        </div>
      </div>
    </div>
  )
}

export default Phone
